"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

var _utils = require("./utils");

function _default(reason, url) {
  return function (Component) {
    var name = (0, _getComponentName.default)(Component);
    var message = "`" + name + "` is deprecated and will be removed in a future version. " + reason;

    var DeprecatedComponent =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2.default)(DeprecatedComponent, _React$Component);

      function DeprecatedComponent() {
        (0, _classCallCheck2.default)(this, DeprecatedComponent);
        return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DeprecatedComponent).apply(this, arguments));
      }

      (0, _createClass2.default)(DeprecatedComponent, [{
        key: "componentWillMount",
        value: function componentWillMount() {
          _devLogger.default.warn({
            message: message,
            key: "deprecated-" + name,
            url: url
          });
        }
      }, {
        key: "render",
        value: function render() {
          this._refCallback = this._refCallback || (0, _utils.makeDecoratorRefCallback)(Component, this);
          return _react.default.createElement(Component, (0, _extends2.default)({}, this.props, {
            ref: this._refCallback
          }));
        }
      }]);
      return DeprecatedComponent;
    }(_react.default.Component);

    DeprecatedComponent.isDeprecated = true;
    DeprecatedComponent.deprecated = {
      reason: reason,
      url: url
    };
    DeprecatedComponent.displayName = "Deprecated(" + (0, _getComponentName.default)(Component) + ")";
    DeprecatedComponent.propTypes = Component.propTypes;
    DeprecatedComponent.defaultProps = Component.defaultProps;
    (0, _utils.attachWrappedComponent)(DeprecatedComponent, Component);
    return DeprecatedComponent;
  };
}

module.exports = exports.default;